// extracted by mini-css-extract-plugin
module.exports = {"v14sl43z":"v14sl43z","loader":"loader"};